import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { BASE_URL } from '../../config';

import { createLocationUrlFromLocation } from '../../core/url/location';
import { shouldRenderDirectTelemedFlow } from '../../core/util/location';

export const CanonicalSourceType = {
  CDP: 'cdp',
  BOOKING_WIDGET: 'booking_widget',
};

class Canonical extends PureComponent {
  render() {
    const { location, sourceType } = this.props;
    // Only situations where we can/should override the canonical are
    // 1) CDPs
    // 2) Booking widgets && !shouldRenderDirectTelemedFlow(location)
    // for the rest of the situations please refer to Html.js getCanonicalLink()
    if (
      sourceType === CanonicalSourceType.CDP ||
      (sourceType === CanonicalSourceType.BOOKING_WIDGET &&
        !shouldRenderDirectTelemedFlow(location))
    ) {
      return (
        <Helmet>
          <link rel="canonical" href={`${BASE_URL}${createLocationUrlFromLocation(location)}`} />
        </Helmet>
      );
    }

    return null;
  }
}

Canonical.propTypes = {
  location: PropTypes.object.isRequired,
  sourceType: PropTypes.string.isRequired,
};

export default Canonical;
